import { padWithZero } from 'shared/lib';

export const cardsData = [
  {
    title: 'Ассистент топ‑менеджера',
    text: 'Стратегическая координация проектов, управление ими и защита решений',
  },
  {
    title: 'Менеджер ИТ‑сервисов',
    text: 'Ведение ИТ-услуг, разбор сбоев, контроль сроков и работа с людьми',
  },
  {
    title: 'Ресурсный менеджер',
    text: 'Расстановка кадров, рост сотрудников, их мотивация и создание резерва',
  },
  {
    title: 'Координатор продаж',
    text: 'Связь отделов, учёт сделок, подготовка предложений, анализ и отчёты',
  },
  {
    title: 'Начальник отдела кадров',
    text: 'Ведение кадров: найм, адаптация и рост. Развитие команды',
  },
  {
    title: 'Менеджер по кадрам',
    text: 'Планирование и подбор кадров, проверка заявок, база штата, отчёты',
  },
  {
    title: 'Координатор проектов',
    text: 'Ведение проектов, работа с людьми, отладка процессов и контроль целей',
  },
  {
    title: 'Ведущий специалист по найму',
    text: 'Управление рекрутерами, план отбора, интервью и приём в штат',
  },
  {
    title: 'Менеджер проекта',
    text: 'Полный цикл управления проектами: планирование, бюджет, риски и управление командой',
  },
].map((data, i) => ({ ...data, index: padWithZero(i + 1) }));
